<template>
  <div class="component-bling">
    <h4 class="text-semibold mb-5">Bling</h4>
    <snow-data-table-header
      class="mb-6"
      @add="add"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block my-9 mx-auto"
              src="@/assets/images/no-content.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <snow-data-table
        v-else
        :columns="InvoicesColumns"
        :data="integrationList"
      />
      <!-- Mobile area -->
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <bling-modal
      v-model="modal"
      :login="token"
      :integrationToEdit="integrationToEdit"
      @clear-edit="
        integrationToEdit = null;
        token = '';
      "
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import blingModal from "@/components/tools/modals/Bling.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationsMixin],
  components: {
    blingModal
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  data() {
    return {
      integration: "bling",
      integrationToEdit: null,
      columns: ["Produto", "Client-ID", "Client-Secret", "Status", ""],
      loading: false,
      modal: false,
      search: "",
      token: ""
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"]),
    InvoicesColumns() {
      return [
        {
          name: "Produto",
          field: "product_name"
        },
        {
          name: "Client ID",
          field: "client_id"
        },
        {
          name: "Client Secret",
          field: "client_secret"
        },
        {
          name: "Status",
          field: "status",
          transform: value => (value ? "Ativo" : "Inativo"),
          color: value => (value ? "green" : "negative"),
          type: "tag"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    loginBling(token) {
      this.$store.dispatch("integration/getBlingHtml", token).then(response => {
        if (!response.auth_status) {
          window.open("", "_blank").document.write(response);
        }
      });
    },
    getStatusColor(status) {
      const colorMap = {
        enable: "text-success",
        review: "text-warning",
        disable: "text-danger",
        fail: "text-danger"
      };
      return colorMap[status];
    },
    getStatusMessage(status) {
      const messageMap = {
        enable: "Ativo",
        review: "Em revisão",
        disable: "Inativo",
        fail: "Token inválido"
      };
      return messageMap[status];
    },
    productName(item) {
      return get(
        this.products.find(p => p.id === item.product_id),
        "name",
        "-"
      );
    },
    getActions(item) {
      return [
        {
          label: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          click: this.changeStatus
        },
        {
          label: "Logar novamente",
          click: () => this.loginBling(item.token)
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Deseja mesmo excluir esta integração?",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Cancelar",
            action: this.submitDelete
          }
        }
      ];
    },
    dispatch() {
      this.$store.dispatch("product/get", { limit: 500 });

      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.status = !item.status;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.status ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
